import type React from "react";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { DefaultLayout } from "~/components/Layout";
import { ModalAction, ModalContent, useModal } from "~/components/Modal";

export const ErrorPage: React.FC = () => {
	const [openModal] = useModal();

	const [searchParams] = useSearchParams();
	const description = searchParams.get("error_description");
	const returnTo = searchParams.get("return_to");

	useEffect(() => {
		openModal({
			type: "error",
			title: "ERROR",
			children: (
				<>
					<ModalContent>
						<div className="text-center">
							{description ?? "Unexpected errors occurred"}
						</div>
					</ModalContent>
					<ModalAction>
						<a
							href={returnTo ?? "/"}
							className="btn btn-lg btn-t4-border rounded-full"
						>
							Go Back
						</a>
					</ModalAction>
				</>
			),
		});
	}, [description, openModal, returnTo]);

	return (
		<>
			<title>Error | TIER IV Account</title>
			<DefaultLayout>
				<main className="main-section flex flex-col justify-center items-center" />
			</DefaultLayout>
		</>
	);
};
